/**
 * product.ads-images — UGC video:
 * - Autoplay muted/loop al entrar en viewport
 * - Autopause al salir
 * - Tap para play/pause manual (mientras sigue en vista)
 */
(function () {
  'use strict';

  var ROOT = '[data-menvora-ads-images]';
  var WRAP = '[data-menvora-ads-images-video-wrap]';
  var VIDEO = '[data-menvora-ads-images-video]';
  var PLAY_BTN = '[data-menvora-ads-images-play]';
  var IN_RATIO = 0.35;

  function reducedMotion() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function ensureVideoSources(video) {
    if (video.dataset.sourcesLoaded === '1') return;
    var sources = video.querySelectorAll('source[data-src]');
    sources.forEach(function (source) {
      var url = source.getAttribute('data-src');
      if (!url) return;
      source.setAttribute('src', url);
      source.removeAttribute('data-src');
      var type = source.getAttribute('data-type');
      if (type) {
        source.setAttribute('type', type);
        source.removeAttribute('data-type');
      }
    });
    if (sources.length) video.load();
    video.dataset.sourcesLoaded = '1';
  }

  function playWrap(wrap) {
    var v = wrap.querySelector(VIDEO);
    if (!v) return;
    ensureVideoSources(v);
    var p = v.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {});
    }
    wrap.classList.add('is-playing');
    wrap.classList.remove('is-paused');
  }

  function pauseWrap(wrap) {
    var v = wrap.querySelector(VIDEO);
    if (!v) return;
    v.pause();
    wrap.classList.remove('is-playing');
    wrap.classList.add('is-paused');
  }

  function toggleWrap(wrap) {
    var v = wrap.querySelector(VIDEO);
    if (!v) return;
    if (v.paused) {
      wrap.dataset.userPaused = '0';
      playWrap(wrap);
    } else {
      wrap.dataset.userPaused = '1';
      pauseWrap(wrap);
    }
  }

  function initWrap(wrap) {
    var v = wrap.querySelector(VIDEO);
    if (!v) return;

    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('muted', '');
    v.loop = true;
    v.controls = false;
    wrap.classList.add('is-paused');
    wrap.dataset.userPaused = '0';
    wrap.dataset.inView = '0';

    var btn = wrap.querySelector(PLAY_BTN);
    if (btn) {
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        toggleWrap(wrap);
      });
    }

    v.addEventListener('click', function (ev) {
      ev.preventDefault();
      toggleWrap(wrap);
    });

    v.addEventListener('play', function () {
      wrap.classList.add('is-playing');
      wrap.classList.remove('is-paused');
    });

    v.addEventListener('pause', function () {
      wrap.classList.remove('is-playing');
      wrap.classList.add('is-paused');
    });

    if (typeof IntersectionObserver !== 'function') {
      if (!reducedMotion()) playWrap(wrap);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var visible =
            entry.isIntersecting && entry.intersectionRatio >= IN_RATIO;
          if (visible) {
            wrap.dataset.inView = '1';
            if (reducedMotion()) return;
            if (wrap.dataset.userPaused === '1') return;
            playWrap(wrap);
          } else {
            wrap.dataset.inView = '0';
            wrap.dataset.userPaused = '0';
            pauseWrap(wrap);
          }
        });
      },
      { threshold: [0, 0.2, 0.35, 0.5, 0.75] }
    );
    io.observe(wrap);
  }

  function fitBenefitLabels(root) {
    var labels = root.querySelectorAll('.product--ads-images__benefit-label');
    labels.forEach(function (el) {
      var box = el.parentElement;
      if (!box) return;
      el.style.transform = 'none';
      el.style.fontSize = '';
      var available = box.clientWidth;
      if (available < 8) return;
      // Ancho natural a font-size CSS; luego scale uniforme para no cortar
      var natural = el.scrollWidth || el.offsetWidth;
      if (!natural) return;
      var scale = Math.min(1, (available - 2) / natural);
      if (scale < 0.35) scale = 0.35;
      el.style.transform = 'scale(' + scale + ')';
    });
  }

  function scheduleFit(root) {
    fitBenefitLabels(root);
    requestAnimationFrame(function () {
      fitBenefitLabels(root);
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        fitBenefitLabels(root);
      });
    }
  }

  function playBenefitTap() {
    var audio =
      document.querySelector('[data-menvora-toalla-benefit-tap]') ||
      document.getElementById('menvora-toalla-benefit-tap');
    if (!audio) return;
    try {
      audio.currentTime = 0;
      var p = audio.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    } catch (e) {
      /* ignore autoplay / missing gesture edge cases */
    }
  }

  function bindBenefitShake(root) {
    root.querySelectorAll('.product--ads-images__benefit-card').forEach(function (card) {
      if (card.dataset.shakeBound === '1') return;
      card.dataset.shakeBound = '1';
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      function shake() {
        playBenefitTap();
        card.classList.remove('is-shake');
        void card.offsetWidth;
        card.classList.add('is-shake');
      }
      card.addEventListener('click', shake);
      card.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          shake();
        }
      });
      card.addEventListener('animationend', function (ev) {
        if (ev.animationName === 'menvora-benefit-shake') {
          card.classList.remove('is-shake');
        }
      });
    });
  }

  function bindStickyTitle(root) {
    var heroTitle = root.querySelector('[data-menvora-hero-title]');
    var sticky = root.querySelector('[data-menvora-sticky-title]');
    if (!heroTitle || !sticky) return;
    if (sticky.dataset.bound === '1') return;
    sticky.dataset.bound = '1';

    function setStuck(on) {
      sticky.classList.toggle('is-stuck', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
    }

    if (typeof IntersectionObserver !== 'function') {
      setStuck(false);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          setStuck(!entry.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: '0px 0px 0px 0px' }
    );
    io.observe(heroTitle);
  }

  function init(root) {
    root.querySelectorAll(WRAP).forEach(initWrap);
    scheduleFit(root);
    bindBenefitShake(root);
    bindStickyTitle(root);
  }

  var resizeTimer = 0;
  function onResize() {
    if (resizeTimer) window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      document.querySelectorAll(ROOT).forEach(fitBenefitLabels);
    }, 80);
  }

  function boot() {
    document.querySelectorAll(ROOT).forEach(init);
    window.addEventListener('resize', onResize, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
